<template lang="pug">
  tr(data-cy="header-row")
    th.fixed
      v-checkbox(
        color=""
        data-cy="select-all"
        @click.native="selectAll"
        :value="this.selected.length > 0"
        :indeterminate='isIndeterminate'
        :value-comparator="() => true"
        hide-details
      )
    template(v-for='(header, index) in headers.headers')
      // this logic in v-show needs to change, might need to redo the headers config file
      th.text-xs-left(
        v-show='isVisible(header) && header.text !== "id" && header.text !== "Is Shared"'
        :key='index'
        @click='setSortBy(header)'
        :class="['column', header.sortable ? 'sortable' : '', sortOrder === -1 ? 'desc' : 'asc', header.value === sortField ? 'active': '']"
      )
        | {{ header.text }}
        v-icon(small v-show='header.sortable === true') arrow_upward
    th.actions
</template>

<script>
export default {
  props: {
    campaigns: {
      type: Array,
    },
    headers: {
      type: Object,
    },
    sortField: {
      type: String,
    },
    sortOrder: {
      type: Number,
    },
    isViewingLastPage: {
      type: Boolean,
    },
    pageLimit: {
      type: Number,
    },
    selected: {
      type: Array,
    },
  },
  computed: {
    isIndeterminate() {
      if (!this.isViewingLastPage) {
        return this.selected.length > 0 && this.selected.length < this.pageLimit;
      } return this.selected.length > 0 && this.selected.length < this.campaigns.length;
    },
  },
  methods: {
    selectAll() {
      this.$emit('click:select-all');
    },
    setSortBy(header) {
      if (header.sortable) {
        this.$emit('click:sort', header.translated_name || header.value);
      }
    },
    isVisible(header) {
      return header.visible;
    },
  },
};
</script>
